import { render, staticRenderFns } from "./SidebarLinkGroup.vue?vue&type=template&id=1bd04f2a&"
import script from "./SidebarLinkGroup.vue?vue&type=script&lang=js&"
export * from "./SidebarLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./SidebarLinkGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SidebarLinkGroup.vue"
export default component.exports